import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { reportWebVitals } from './reportWebVitals';

/**
 * Mobile viewport height tokens.
 * Prefer visualViewport when present so soft keyboards don't drive --vh-safe
 * negative via (innerHeight - (screen.height - innerHeight)).
 */
function setViewportHeight() {
  const height =
    (window.visualViewport && window.visualViewport.height) || window.innerHeight;
  const vh = height * 0.01;
  document.documentElement.style.setProperty('--vh', `${vh}px`);
  document.documentElement.style.setProperty('--vh-safe', `${Math.max(0, height)}px`);
  // Slightly shorter band for auth forms (keyboard-friendly); never negative.
  const safeSmall = Math.max(240, Math.round(height * 0.92));
  document.documentElement.style.setProperty('--vh-safe-small', `${safeSmall}px`);
}

setViewportHeight();

window.addEventListener('resize', setViewportHeight);
window.addEventListener('orientationchange', setViewportHeight);
if (window.visualViewport) {
  window.visualViewport.addEventListener('resize', setViewportHeight);
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
